<template>
  <RoleDrawer ref="drawerComponentRole" v-model="drawer" @role-updated="callApi" v-model:editUser="editUser" />
  <v-container>
    <div class="exploration-table">
      <div class="table-top-content">
        <div class="d-flex align-center">
          <div class="title"><span class="userCount">{{ filteredRoles.length }} roles</span>Manage your roles and permissions
            here</div>
        </div>
        <div>
          <div class="test-pdf-div">
            <v-btn class="pdf-btn" @click="openSideModal">
              <span><v-icon size="16">mdi-plus</v-icon> <span></span> Add Role</span>
            </v-btn>
          </div>
        </div>
      </div>
      <!-- Search Input -->
      <div class="search-container">
        <v-text-field
          v-model="searchQuery"
          placeholder="Search roles, permissions, descriptions..."
          prepend-inner-icon="mdi-magnify"
          variant="outlined"
          density="compact"
          clearable
          hide-details
          class="search-input"
        ></v-text-field>
      </div>
      <!-- Add a scrollable wrapper around the table -->
      <div class="table-scroll-wrapper">
        <v-data-table-server v-model:items-per-page="itemsPerPage" :headers="headers" :items="filteredRoles"
          :items-per-page-options="pageOptions" :items-length="filteredRoles.length" :loading="loading" item-value="name"
          @update:options="handlePageChange" fixed-header :height="tableScrollHeight">
          <template v-slot:loader>
            <v-skeleton-loader type="table-row-divider" :loading="loading" :types="{
              'table-row-divider': {
                height: 'calc(100vh - 425px)',
                rows: 5
              }
            }" style="background-color: #ffffff;">
            </v-skeleton-loader>
          </template>
          <template v-slot:headers>
            <tr>
              <th v-for="header in headers" :key="header.value" class="text-left search-dropdown-menu header-cell"
                :style="{ backgroundColor: 'transparent' }">
                <div class="d-flex align-center justify-space-between">
                  <div class="sort-icon-title d-flex align-center" style="gap: 10px">
                    <!-- <div class="sort-icons">
                      <div class="img-div">
                        <img :src="sort_up" alt="sort-up" class="cursor-pointer" @click="sort(header.title, 'asc')" />
                      </div>
                      <div class="img-div">
                        <img :src="sort_down" alt="sort-down" class="cursor-pointer"
                          @click="sort(header.title, 'desc')" />
                      </div>
                    </div> -->
                    {{ header.title }}
                  </div>
                </div>
              </th>
            </tr>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <div class="user-info">
                  <div class="d-flex align-center">
                    <span class="item-name">{{ item.name }}</span>
                    <!-- <v-chip  class="status-chip" color="#ABEFC6"
                      text-color="#067647" size="small">
                      Active
                    </v-chip> -->
                  </div>
                  <span class="item-description">{{ item.description }}</span>
                </div>
              </td>
              <td>
                <span v-for="permission in item.permissions" :key="permission" class="clickable-cell no-bg">
                  {{ permission }}
                </span>
              </td>
              <td>
                <v-menu offset-y>
                  <template v-slot:activator="{ props }">
                    <v-btn variant="text" class="float-right" v-bind="props">
                      <img :src="elipse" />
                    </v-btn>
                  </template>
                  <v-list dense class="custom-list">
                    <v-list-item @click="editUserModal(item)" class="custom-list-item">
                      <v-list-item-content class="d-flex align-center">
                        <img class="mr-2 icon-size" :src="pencil" />
                        <v-list-item-title>Edit</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="showDeleteConfirmation(item)" class="custom-list-item">
                      <v-list-item-content class="d-flex align-center">
                        <img class="mr-2 icon-size" :src="delete_icon" />
                        <v-list-item-title>Delete</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="space-between">
              <v-btn icon :disabled="page === 1" @click="prevPage">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn icon :disabled="page === numberOfPages" @click="nextPage">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-row>
          </template>
          <template v-slot:no-data>
            <div class="d-flex justify-center align-center pa-4">
              No data available
            </div>
          </template>
        </v-data-table-server>
      </div>
    </div>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout">
      {{ snackbar.message }}
    </v-snackbar>
    
    <!-- Delete Confirmation Modal -->
    <v-dialog transition="dialog-top-transition" v-model="confirmDeleteDialog" width="417">
      <div class="cross-btn-div" @click="closeDeleteConfirmation">
        <v-img :src="close_icon" alt="close"></v-img>
      </div>
      <v-alert title="Delete Role" :text="confirmDeleteText">
        <div class="alert-btns-div">
          <v-btn class="cancel-btn" flat @click="closeDeleteConfirmation">Cancel</v-btn>
          <v-btn class="delete-btn" flat @click="confirmDeleteRole" :loading="deleteLoading">
            <v-img :src="delete_icon" alt="delete-icon" width="16" height="15" class="mr-2"></v-img>
            Delete Role</v-btn>
        </div>
      </v-alert>
    </v-dialog>
  </v-container>
</template>

<script>
import api from "../../axiosInterceptor";
import axios from "axios";
import RoleDrawer from "@/components/Roles/RoleDrawer.vue";
export default {
  name: "TableData",
  components: {
    RoleDrawer,
  },
  props: {
    roles: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sort_up: require("../../assets/Svg/Table/up.svg"),
      sort_down: require("../../assets/Svg/Table/down.svg"),
      reset_icon: require("../../assets/Images/reset.png"),
      close_icon: require("../../assets/Images/close-circle.png"),
      elipse: require("../../assets/Svg/elipse.svg"),
      pencil: require("../../assets/Svg/Dashboard/pencil.svg"),
      delete_icon: require("../../assets/Svg/Dashboard/delete.svg"),
      itemsPerPage: localStorage.getItem('itemsPerPage') || 20,
      headers: [
        { title: 'Role', key: 'role', sortable: false },
        { title: 'Permissions', key: 'permission', sortable: false },
        { title: 'Actions', key: 'action', sortable: false }
      ],
      totalItems: 0,
      page: 1,
      pageOptions: [20, 50, 100, 200, 300, 400, 500],
      searchQuery: '',
      searchLoading: false,
      loadingCsv: false,
      drawer: false,
      user: {
        name: '',
        email: '',
        role: '',
      },
      snackbar: {
        visible: false,
        message: "",
        color: "success",
        timeout: 3000,
      },
      editUser: "",
      confirmDeleteDialog: false,
      confirmDeleteText: "",
      deleteLoading: false,
      selectedRole: null
    };
  },
  computed: {
    // Set a fixed height for the scrollable table area
    tableScrollHeight() {
      // Use full available height
      return "calc(100vh - 200px)";
    },
    serverItems() {
      return this.roles; // Directly mapping props to computed property
    },
    filteredRoles() {
      if (!this.searchQuery) {
        return this.roles;
      }
      
      const query = this.searchQuery.toLowerCase();
      return this.roles.filter(role => {
        // Search in role name
        const nameMatch = role.name && role.name.toLowerCase().includes(query);
        
        // Search in role description
        const descriptionMatch = role.description && role.description.toLowerCase().includes(query);
        
        // Search in permissions
        const permissionsMatch = role.permissions && role.permissions.some(permission => 
          permission.toLowerCase().includes(query)
        );
        
        return nameMatch || descriptionMatch || permissionsMatch;
      });
    }
  },
  methods: {
    callApi() {
      this.$emit("roles-api-call");
    },
    showSnackbar(message, color = "success") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.visible = true;
    },
    openSideModal() {
      this.$refs.drawerComponentRole.resetForm();
      this.editUser = null;
      this.drawer = true;
    },
    editUserModal(item) {
      this.editUser = item
      this.drawer = true;
    },
    handlePageChange({ page, itemsPerPage }) {
      this.$emit('update:pagination', { page, itemsPerPage });
      localStorage.setItem('itemsPerPage', itemsPerPage);
    },
    prevPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    nextPage() {
      if (this.page < this.numberOfPages) {
        this.page++;
      }
    },
    showDeleteConfirmation(item) {
      this.selectedRole = item;
      this.confirmDeleteText = `Are you sure you want to delete the role "${item.name}"? This action cannot be undone.`;
      this.confirmDeleteDialog = true;
    },
    closeDeleteConfirmation() {
      this.confirmDeleteDialog = false;
      this.selectedRole = null;
      this.deleteLoading = false;
    },
    async confirmDeleteRole() {
      if (!this.selectedRole) return;
      
      this.deleteLoading = true;
      const roleId = this.selectedRole.id;

      try {
        const response = await api.delete(`${process.env.VUE_APP_API_URL}public/api/admin/roles/${roleId}`);

        if (response && response.data) {
          if (response.data.statusCode === 200 || response.data.statusCode === 201) {
            this.showSnackbar(response.data.message || "Role deleted successfully!", "success");
            this.$emit("roles-api-call");
            this.closeDeleteConfirmation();
          } else {
            this.showSnackbar(response.data.message || "Error deleting role", "error");
          }
        } else {
          this.showSnackbar("Unexpected response from server", "error");
        }
      } catch (error) {
        this.showSnackbar(error.response?.data?.message || "Error deleting role", "error");
      } finally {
        this.deleteLoading = false;
      }
    }

  },
  watch: {
    roles: {
      handler(newVal) {
        this.totalItems = newVal.length; // Update total items count
      },
      immediate: true,
      deep: true
    }
  }
};
</script>


<style scoped>
.exploration-table {
  position: relative;
}

.pdf-btn
{
  width: 100% !important;
}

.table-scroll-wrapper {
  height: calc(100vh - 200px);
  overflow-y: auto;
  /* Optional: add a border or background if you want to visually separate the scroll area */
}

.table-title {
  font-size: 23.50px;
  font-weight: bold;
  margin-bottom: 10px;
}

.applied-filters {
  font-size: 13.50px;
  font-weight: 600;
  line-height: 16px;
  color: #FFFFFF;
  letter-spacing: 0.2px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-family: "Inter", sans-serif !important;
}

.applied-filters>span {
  margin-right: 10px;
  border-right: 1px solid #FFFFFF;
  padding-right: 10px;
  font-size: 11.50px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.2px;
}

.applied-filters span:nth-child(5) {
  border-right: none !important;
}

.test-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-dropdown {
  background: white;
  width: 100%;
  border-radius: 4px;
  max-height: 200px;
}

.custom-list {
  width: auto;
  min-width: 120px;
}

.custom-list-item {
  min-width: fit-content;
  /* Prevents unnecessary expansion */
}

.icon-size {
  width: 18px;
  height: 18px;
}

.v-list-item-title {
  width: 91px !important;
}

.user-info {
    border-radius: 8px; /* Rounded corners */
    padding: 8px; /* Padding for spacing */
}

.item-name {
    font-weight: bold; /* Bold text */
    font-size: 11.5px; /* Normal size */
    margin-right: 8px; /* Space between name and status */
}

.item-description {
    font-weight: 300; /* Lighter font weight */
    color: #6c757d; /* Light gray */
    font-size: 11.5px; /* Slightly smaller text */
    display: block; /* Ensure it appears below */
}

.status-chip {
      border-radius: 12px; /* Rounded corners for chip */
      font-size: 0.25rem; /* Small font */
      margin-left: 8px;
}

/* Override v-data-table__thead positioning for this component */
:deep(.v-data-table__thead) {
  top: 0px !important;
}
.v-table.v-table--fixed-header > .v-table__wrapper > table > thead > tr > th {
  top: 0px !important;
}
/* Override th positioning within thead for this component */
:deep(.v-data-table__thead th) {
  top: 0px !important;
}

/* Ensure headers are visible and properly styled */
.header-cell {
  color: #ffffff !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  padding: 16px !important;
  border: none !important;
}

.dark-mode .v-data-table__tbody .v-btn__content img, .v-list-item__content img {
    filter: brightness(0) invert(1) !important;
}

.v-list-item--density-default.v-list-item--one-line
{
  min-height: 0px !important;
  padding: 0px !important;
  margin: 6px 8px !important;
}

.clickable-cell
{
  margin: 4px 0px !important;
}

.search-container {
  margin: 6px;
}

.search-input {
  width: 100%;
}

.search-input :deep(.v-field__outline) {
  border-color: #e0e0e0;
}

.search-input :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2;
}

</style>